exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#bsh-tab button[data-v-6a796104]{background-color:#fff}.active[data-v-6a796104]{color:#00f!important}", ""]);

// exports
